import authAxios from '../authorization/axios';
import constants from '../constants';

export const changeAccount = async (data: any) => {
  const main = constants.api.changeAccount;

  // TODO: typing the response.
  const response = await authAxios.post(main, data);

  return response;
};


export const clawback = async (nftId: any, data: any) => {
  const main = constants.api.clawback.replace('{nftId}', nftId.toString());

  // TODO: typing the response.
  const response = await authAxios.post(main, data);
  return response;
};


export const mergeContact = async (contactMail: string, data: any) => {
  const main = constants.api.mergeContact.replace('{contactMail}', contactMail!);

  // TODO: typing the response.
  const response = await authAxios.post(main, data);

  return response;
};

export const nftMove = async (nftId: any, data: any) => {
  const main = constants.api.nftMove.replace('{nftId}', nftId!);

  // TODO: typing the response.
  const response = await authAxios.post(main, data);

  return response;
};

